export function getConfiguracionVuex (state) {
  return state.configuracionVuex;
}
